import { ApiSchema } from "@api-types";
import { useObservable } from "@rsm";
import { getClientService } from "services/client.service";
import { useHasPolicy } from "hooks/useHasPolicy";

const MANAGE_PATH: Record<ApiSchema.ClientTierLookup, string> = {
  Team: "manage-team",
  Org: "manage-org",
  Enterprise: "manage-enterprise",
};

const TRANSACTIONS_POLICY: Record<ApiSchema.ClientTierLookup, ApiSchema.Policy> = {
  Team: "SharedViewerTeamAdmin",
  Org: "SharedViewerOrgAdmin",
  Enterprise: "SharedViewerEnterpriseAdmin",
};

/**
 * The transactions route path for the current client, or null when the user lacks the policy to
 * reach it. Restricted (churned) users are auto-redirected here when it's non-null, and shown the
 * inactive landing page when it's null (e.g. a team member with no org/transactions access).
 * Returns undefined while the client or policy is still resolving.
 */
export const useChurnTransactionsPath = (): string | null | undefined => {
  const client = useObservable(getClientService().client$, null);
  const tier = client?.tier;
  const canViewTransactions = useHasPolicy(tier ? TRANSACTIONS_POLICY[tier] : "SharedViewerTeamAdmin");

  if (!client || !tier || canViewTransactions === null) {
    return undefined;
  }
  return canViewTransactions ? `/${client.id}/${MANAGE_PATH[tier]}/transactions` : null;
};
